import { Catalog } from '@a2ui/web_core/v0_9';
import { Column, Explain, Progress } from './components/layout';
import { Choice, Flashcard, GapFill, Reorder, SayItBack } from './components/exercises';
import { Dictation, SpotIt } from './components/ladder-cards';
import { SayFromMeaning, SoundAlike } from './components/listen-cards';

import { CATALOG_ID, SURFACE_ID } from './api';
export { CATALOG_ID, SURFACE_ID };

export const exerciseCatalog = new Catalog(CATALOG_ID, [
  Column,
  Explain,
  Progress,
  Flashcard,
  GapFill,
  Choice,
  Reorder,
  SayItBack,
  SpotIt,
  Dictation,
  SoundAlike,
  SayFromMeaning,
]);
